/** Glifo — dibuja el ícono de Material Symbols que corresponde a un emoji de un mapa de datos (ver lib/emojiAIcono.js).
 *  Los puntos de color (🔴🟡🟢…) se dibujan como un punto real. */
import { iconoDeEmoji } from "../lib/emojiAIcono.js";

const PUNTOS = { "🔴": "#DC2626", "🟠": "#F97316", "🟡": "#F59E0B", "🟢": "#10B981", "🔵": "#3B82F6", "🟣": "#8B5CF6", "⚪": "#9CA3AF", "⚫": "#111318" };

export default function Glifo({ g, respaldo = "circle", className = "", style }) {
  const punto = PUNTOS[String(g || "").trim()];
  if (punto) return <span aria-hidden="true" className={`inline-block h-2.5 w-2.5 shrink-0 rounded-full align-middle ${className}`} style={{ background: punto, ...style }} />;
  return <span className={`msr ${className}`} style={style} aria-hidden="true">{iconoDeEmoji(g, respaldo)}</span>;
}
